import { render, staticRenderFns } from "./orderReturnDetail.vue?vue&type=template&id=a6929362&"
import script from "./orderReturnDetail.vue?vue&type=script&lang=js&"
export * from "./orderReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderReturnDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports